import { createAction } from '@gef-ui/utils/fsaActions';
import { appContextActions } from '../../constants';
/**
 * update access token
 *
 * @documented
 * @category Action
 * @example
 *
 * 	updateAccessToken('foo')
 *
 */ export const updateAccessToken = createAction(appContextActions.UPDATE_ACCESS_TOKEN);
/**
 * update refresh token
 *
 * @documented
 * @category Action
 * @example
 *
 * 	updateRefreshToken('foo')
 *
 */ export const updateRefreshToken = createAction(appContextActions.UPDATE_REFRESH_TOKEN);
/**
 * merge app context
 *
 * @documented
 * @category Action
 * @example
 *
 * 	mergeAppContext({ foo: 'foo', bar: 'bar' })
 *
 */ export const mergeAppContext = createAction(appContextActions.MERGE_APP_CONTEXT);
/**
 * clear app context to its initial state
 *
 * @documented
 * @category Action
 * @example
 *
 * 	clearAppContext()
 *
 */ export const clearAppContext = createAction(appContextActions.CLEAR_APP_CONTEXT);
/**
 * setting pending state of access token
 *
 * @documented
 * @category Action
 * @example
 *
 * 	setIsPending(true)
 *
 */ export const setIsPending = createAction(appContextActions.SET_IS_PENDING);
